import React, { useEffect, useState } from 'react';
import { stripHtmlToText } from './siteContent';

const paragraphStyle = {
  margin: '0 0 1.25rem 0',
};

const baseStyle = {
  marginBottom: '40px',
  fontSize: '1.1rem',
  lineHeight: '1.7',
};

function renderParagraphs(text, style = {}) {
  const normalized = stripHtmlToText(text);
  if (!normalized) return null;

  return normalized
    .split(/\n\s*\n/)
    .map(part => part.trim())
    .filter(Boolean)
    .map((part, index) => (
      <p key={index} style={{ ...paragraphStyle, ...style }}>
        {part.split('\n').map((line, lineIndex, lines) => (
          <React.Fragment key={lineIndex}>
            {line}
            {lineIndex < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </p>
    ));
}

function EditablePageContent({ content, isAdmin, isLoading, onSave, style = {} }) {
  const [draft, setDraft] = useState(() => stripHtmlToText(content));

  useEffect(() => {
    setDraft(stripHtmlToText(content));
  }, [content]);

  if (isLoading) {
    return <p style={{ color: '#6b7280', ...style }}>Loading page content...</p>;
  }

  if (isAdmin) {
    return (
      <textarea
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={() => onSave(draft)}
        rows={8}
        style={{
          ...baseStyle,
          ...style,
          width: '100%',
          outline: '2px dashed #93c5fd',
          borderRadius: '8px',
          padding: '12px',
          border: '1px solid #d1d5db',
          resize: 'vertical',
          fontFamily: 'inherit',
          whiteSpace: 'pre-wrap',
        }}
        title="Admin edit mode: type here. Blank lines create new paragraphs. Changes save when you click away."
      />
    );
  }

  const paragraphs = renderParagraphs(content, style);
  if (!paragraphs?.length) return null;

  return <div style={{ ...baseStyle, ...style }}>{paragraphs}</div>;
}

export default EditablePageContent;